import { Bill } from './bill.model';

export function hasTransmittedPayment(bill: Bill): boolean {
    return bill.payments.some(
        (payment) =>
            payment.completedPaymentPackageCount > 0 ||
            (payment.taskSummary && payment.taskSummary.TransmitComplete),
    );
}
